import React, { useState } from 'react';
import PropTypes from 'prop-types';
// import { connect } from 'dva';
import ExpandableDetailHeader from './ExpandableDetailHeader';

function ExpandableDetail(props) {

  const [isExpanded, setIsExpanded] = useState(props.isExpanded || false);

  const expand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <>
      <ExpandableDetailHeader
        titleIcon={props.titleIcon || null}
        title={props.title}
        label={props.label}
        onClickExpand={expand}
        isExpanded={isExpanded}
        style={props.style}
      />
      {isExpanded && props.children}
    </>
  );
}

ExpandableDetail.propTypes = {
  titleIcon: PropTypes.object,
  title: PropTypes.string,
  label: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
  isExpanded: PropTypes.bool,
};

export default ExpandableDetail;